import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Button, ButtonGroup } from "@mui/material";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';

type TaskListToggleProps = {
  activeMode: "time-study" | "task-counter";
};

const activeStyle = {
  backgroundColor: "#E0F2FE",
  color: "#203C77",
  textTransform: "capitalize" as const,
  fontWeight: 400,
  borderColor: "#EBF2FE",
  "&:hover": {
    backgroundColor: "#BAE6FD",
    borderColor: "#EBF2FE",
  },
}; 

const inactiveStyle = {
  backgroundColor: "#fff",
  color: "#203C77",
  textTransform: "capitalize" as const,
  fontWeight: 400,
  borderColor: "#EBF2FE",
  "&:hover": {
    backgroundColor: "#f0f4fa",
    borderColor: "#EBF2FE",
  },
};

export const TaskListToggle: FC<TaskListToggleProps> = ({ activeMode }) => {
  const navigate = useNavigate();

  return (
    <ButtonGroup variant="outlined" size="small">
      <Button
        sx={activeMode === "time-study" ? activeStyle : inactiveStyle}
        onClick={() => navigate("/tasks-list-management")}
      >
        <TimerOutlinedIcon fontSize="small" />
        Time Study
      </Button>
      <Button
        sx={activeMode === "task-counter" ? activeStyle : inactiveStyle}
        onClick={() => navigate("/task-counter")}
      >
        <TaskAltIcon fontSize="small"/>
        Task Counter
      </Button>
    </ButtonGroup>
  );
};
